module.exports = __webpack_public_path__ + "static/media/good_bye_2016.62b1c8f3.png";